import axios from 'axios';

const API_URL = '/api/user-settings';

/**
 * Get all users in the system
 * @returns {Promise<Object>} Response with users array
 */
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}/users`);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

/**
 * Get all available lenders
 * @returns {Promise<Object>} Response with lenders array
 */
export const getAllLenders = async () => {
  try {
    const response = await axios.get(`${API_URL}/lenders`);
    return response.data;
  } catch (error) {
    console.error('Error fetching lenders:', error);
    throw error;
  }
};

/**
 * Get lender access settings for a specific user
 * @param {string} email - User email
 * @returns {Promise<Object>} Response with user's lender access settings
 */
export const getUserLenderAccess = async (email) => {
  try {
    const response = await axios.get(`${API_URL}/user-access/${encodeURIComponent(email)}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user lender access:', error);
    throw error;
  }
};

/**
 * Update lender access settings for a specific user
 * @param {string} email - User email
 * @param {Array} lenderAccess - Array of lender access settings
 * @returns {Promise<Object>} Response confirming the update
 */
export const updateUserLenderAccess = async (email, lenderAccess) => {
  try {
    const response = await axios.post(`${API_URL}/user-access/${encodeURIComponent(email)}`, {
      lenderAccess
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user lender access:', error);
    throw error;
  }
};

/**
 * Check if a user has access to a specific lender
 * @param {string} email - User email
 * @param {string} lenderId - Lender ID
 * @returns {Promise<Object>} Response with access status
 */
export const checkUserLenderAccess = async (email, lenderId) => {
  try {
    const response = await axios.get(`${API_URL}/check-access/${encodeURIComponent(email)}/${lenderId}`);
    return response.data;
  } catch (error) {
    console.error('Error checking user lender access:', error);
    throw error;
  }
};

/**
 * Update auto-decline bypass permission for a user
 * @param {string} email - User email
 * @param {boolean} canBypassAutoDecline - Whether user can bypass auto-decline
 * @returns {Promise<Object>} Response confirming the update
 */
export const updateBypassPermission = async (email, canBypassAutoDecline) => {
  try {
    const response = await axios.post(`${API_URL}/bypass-permission/${encodeURIComponent(email)}`, {
      canBypassAutoDecline
    });
    return response.data;
  } catch (error) {
    console.error('Error updating bypass permission:', error);
    throw error;
  }
}; 